import Component from '../classes/Component';
import Swiper, {Navigation, Pagination} from 'swiper';
import variables from '../variables';
import {isElement} from '../helpers/_utilities';
import {$style} from '../helpers/style';
import {$dom} from '../helpers/dom';

const {getAll, get} = $dom;
const {offset} = $style;

export default function carousel(
  sectionSelector = '.js-carousel',
  titleSelector = '.js-carousel-title',
  prevBtnSelector = '.js-carousel-prev',
  nextBtnSelector = '.js-carousel-next',
  paginationSelector = '.js-carousel-pagination',
  maxCountWithoutDynamicBullets = variables.maxCountWithoutDynamicBullets
) {

  const initCarousels = () => {

    return getAll(sectionSelector).map(section => {

      if (isElement(section)) {
        const
          swiperEl = get('.swiper', section),
          titleEl = get(titleSelector, section)
        ;
        if (isElement(swiperEl) && isElement(titleEl)) {
          return new Swiper(swiperEl, {
            speed: variables.carouselDefaultDuration,
            modules: [Navigation, Pagination],
            slidesPerView: 'auto',
            spaceBetween: variables.windowWidth >= variables.breakpoints.xl ? 30 : 15,
            slidesOffsetBefore: offset(titleEl).left,
            slidesOffsetAfter: variables.gridGap,
            navigation: {
              nextEl: get(nextBtnSelector, section),
              prevEl: get(prevBtnSelector, section),
              disabledClass: variables.classNames.disabled
            },
            pagination: {
              el: get(paginationSelector, section),
              type: 'bullets',
              clickable: true,
              dynamicBullets: true,
              dynamicMainBullets: maxCountWithoutDynamicBullets,
              renderBullet: function (index, className) {
                return `<span class='${className}'><span class='swiper-pagination-bullet-inner'>${index}</span></span>`;
              },
            },
          })
        }
      }
    })
  };

  return new Component({
    name: 'carousel',
    requiredSelector: sectionSelector,
    onCreate() {
      this.carousels = [];
    },
    onInit() {
      this.carousels = initCarousels();
    },
    onDestroy() {
      this.carousels = this.carousels.filter(c => {
        if (c instanceof Swiper) c.destroy();
        return false
      });
    }
  })
}